import small from '../../images/crest.svg' with { type: 'url' };
import large from '../../images/header/header-logo.svg' with { type: 'url' };
import * as style from './Logo.module.css';
export default function Logo() {
    return (
        <a className={style.logo} href="/" aria-label="Tilbake til forsiden" title="Hjem">
            <img src={small} srcSet={`${small} 36w, ${large} 212w`} sizes="(min-width: 768px) 261px, 1px" alt="logo" />
        </a>
    );
}
